/* eslint-disable react/no-unused-prop-types */
import React from 'react'
import { array, bool, func } from 'prop-types'
import { Container, Row, Col, TitleText } from '@paypalcorp/pp-react'
import DWSubSection from './DWSubSection'

const DWSections = ({ sections = [], onSectionClick, hideTitle = false }) =>
  sections.map(
    ({
      sectionId,
      sectionName,
      hasElmoTreatment,
      subSections = [],
      isEnabled,
    }) =>
      isEnabled &&
      hasElmoTreatment && (
        <Container
          fluid
          id={sectionId}
          key={sectionName}
          className="dw-section-container"
        >
          {!hideTitle && (
            <Row row={{ justifyContent: 'center' }} noGutters>
              <Col xs={12} sm={8}>
                <TitleText
                  id={`${sectionId}Header`}
                  className="dw-section-header"
                >
                  {sectionName}
                </TitleText>
              </Col>
            </Row>
          )}
          {subSections.map(
            (subSection, index) =>
              subSection.featureEnabled &&
              subSection.hasElmoTreatment && (
                <DWSubSection
                  key={`dw-sub-section-${index}`}
                  onSectionClick={onSectionClick}
                  {...subSection}
                />
              ),
          )}
        </Container>
      ),
  )

DWSections.propTypes = {
  sections: array,
  onSectionClick: func,
  hideTitle: bool,
}

DWSections.displayName = 'DWSections'

export default DWSections
